var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.004 512.004",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 76.802,
    y: 247.47,
    style: {
      fill: "#D81B60"
    },
    width: 51.2,
    height: 187.733
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.861,
    y: 170.329,
    style: {
      fill: "#AFB42B"
    },
    width: 51.883,
    height: 265.216
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.602,
    y: 213.337,
    style: {
      fill: "#5E35B1"
    },
    width: 51.2,
    height: 221.867
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.002,
    y: 128.003,
    style: {
      fill: "#00796B"
    },
    width: 51.2,
    height: 307.2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.535,230.403H68.269c-4.693,0-8.533,3.84-8.533,8.533v204.8c0,4.693,3.84,8.533,8.533,8.533h68.267 c4.693,0,8.533-3.84,8.533-8.533v-204.8C145.069,234.243,141.229,230.403,136.535,230.403z M128.002,435.203h-51.2V247.47h51.2 V435.203z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238.935,153.945h-68.267c-4.523,0-8.192,3.669-8.192,8.192v281.6c0,4.523,3.669,8.192,8.192,8.192h68.267 c4.523,0,8.192-3.669,8.192-8.192v-281.6C247.127,157.614,243.458,153.945,238.935,153.945z M230.743,435.545h-51.883V170.329 h51.883V435.545z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.335,196.27h-68.267c-4.693,0-8.533,3.84-8.533,8.533v238.933c0,4.693,3.84,8.533,8.533,8.533h68.267 c4.693,0,8.533-3.84,8.533-8.533V204.803C349.869,200.11,346.029,196.27,341.335,196.27z M332.802,435.203h-51.2V213.337h51.2 V435.203z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M443.736,110.937h-68.267c-4.693,0-8.533,3.84-8.533,8.533v324.267c0,4.693,3.84,8.533,8.533,8.533h68.267 c4.693,0,8.533-3.84,8.533-8.533V119.47C452.269,114.777,448.429,110.937,443.736,110.937z M435.202,435.203h-51.2v-307.2h51.2 V435.203z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.411,162.137c1.775,0,3.575-0.555,5.111-1.707l98.5-73.873l97.894,40.789c2.918,1.229,6.255,0.725,8.687-1.263 l88.465-72.38v23.1c0,4.719,3.823,8.533,8.533,8.533c4.71,0,8.533-3.814,8.533-8.533V34.137c0-4.719-3.823-8.533-8.533-8.533h-51.2 c-4.71,0-8.533,3.814-8.533,8.533s3.823,8.533,8.533,8.533h29.184l-81.826,66.961l-97.673-40.704c-2.79-1.161-5.99-0.759-8.405,1.05 l-102.4,76.8c-3.772,2.825-4.531,8.175-1.707,11.938C97.248,160.959,99.817,162.137,102.411,162.137z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M509.502,471.837l-25.6-25.6c-3.337-3.337-8.73-3.337-12.066,0s-3.337,8.73,0,12.066l11.034,11.034H42.669V29.136 L53.702,40.17c1.664,1.664,3.849,2.5,6.033,2.5c2.185,0,4.369-0.836,6.033-2.5c3.337-3.337,3.337-8.73,0-12.066l-25.6-25.6 c-3.337-3.337-8.73-3.337-12.066,0l-25.6,25.6c-3.337,3.337-3.337,8.73,0,12.066s8.73,3.337,12.066,0l11.034-11.034V477.87 c0,4.719,3.823,8.533,8.533,8.533h448.734l-11.034,11.034c-3.337,3.337-3.337,8.73,0,12.066c1.664,1.664,3.849,2.5,6.033,2.5 s4.369-0.836,6.033-2.5l25.6-25.6C512.838,480.566,512.838,475.173,509.502,471.837z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AD1457"
    },
    points: "110.935,247.47 110.935,418.137 76.802,418.137 76.802,435.203 128.002,435.203  128.002,247.47 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#827717"
    },
    points: "213.677,170.329 213.677,418.478 178.861,418.478 178.861,435.545 230.743,435.545  230.743,170.329 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#311B92"
    },
    points: "315.735,213.337 315.735,418.137 281.602,418.137 281.602,435.203 332.802,435.203  332.802,213.337 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#004D40"
    },
    points: "418.135,128.003 418.135,418.137 384.002,418.137 384.002,435.203 435.202,435.203  435.202,128.003 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.8144f283652668ff0d766ebbb18d29f0.svg";
export { ForwardRef as ReactComponent };